import React, { useState } from "react";

import BuilderTabs from "../../../Layouts/BuilderTabs";
import ActivityJobs from "./Jobs/ActivityJobs";
import ActivityForm from "./ActivityForm/ActivityForm";
import ActivitySettings from "./Settings/ActivitySettings";
import NotesAndTags from "../../../components/BuilderComponents/NotesAndTags";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import ActivityJobFlow from "./JobFlow/ActivityJobFlow";
import { useParams } from "react-router-dom";
import ActivityFlowRenderer from "./ActivityFlow/ActivityFlowRenderer";

const ActivityEditor = ({
  activityForm,
  activityData,
  setActivityData,
  allStatesActivityObj,
  handleNotesAndTag,
  allJobs
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [activeTab, setActiveTab] = useState("Jobs");
  const { markClean, isDirty } = useDirtyChecker(activityData);
  const { smId, activityId } = useParams();
  console.log("activityData", activityData);
  const tabData = [
    {
      label: "Jobs",
      content: (
        <ActivityJobs
          allStatesActivityObj={allStatesActivityObj}
          activityData={activityData}
          setActivityData={setActivityData}
          allJobs={allJobs}
        />
      )
    },
    {
      label: "Job Node",
      content: (
        <ActivityJobFlow
          activityData={activityData}
          setActivityData={setActivityData}
          allJobs={allJobs}
          allStatesActivityObj={allStatesActivityObj}
          currentTab={activeTab}
        />
      )
    },
    {
      label: "Activity V2",
      content: <ActivityFlowRenderer activityData={activityData} setActivityData={setActivityData} allJobs={allJobs} />
    },
    {
      label: "Form",
      content: <ActivityForm activityForm={activityForm} />
    },
    {
      label: "Settings",
      content: (
        <ActivitySettings activityForm={activityForm} activityData={activityData} setActivityData={setActivityData} />
      )
    }
  ];

  const handleSaveActivity = async () => {
    try {
      setIsSaving(true);
      let url = `/state-machine/${smId}/activities/${activityId}`;
      const { message, data } = await axiosInstance.put(url, activityData);
      toastSuccess(message);
      setIsSaving(false);
      markClean();
      return { data: data, message };
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  };

  return (
    <div>
      <GenericActionBar
        path={
          <div>
            <em>SM-Workflow</em> → <span>{`Activities/${activityData.name}`}</span>
          </div>
        }
        actions={[
          {
            key: "notes",
            icon: "notes",
            title: "Notes",
            onClick: () => setShowNotesModal(!showNotesModal)
          },
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSaveActivity
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />
      <BuilderTabs
        tabs={tabData}
        tabsClass={"activity_tab"}
        containerClass="page-action-bar-top align-start"
        onChange={setActiveTab}
      />
      <BuilderModal isOpen={showNotesModal} onClose={() => setShowNotesModal(false)} modalName="Add Notes">
        <NotesAndTags notesValue={activityData.description || ""} onChange={handleNotesAndTag} />
      </BuilderModal>
    </div>
  );
};

export default ActivityEditor;
